import { ChangeEvent, useState } from 'react';
import { QTabContext, QTabList, QTab, QTabPanel, QContainer, QDateRange, QTypography } from '@kw/quokka-ui';
import { Box } from '@mui/material';
import { AppInventory } from './AppInventory';
import { RiskInsights } from './RiskInsights';
import { PolicyViolations } from './PolicyViolations';
import moment from 'moment';

export const Dashboards = () => {
  const [activeTab, setActiveTab] = useState<number>(0);
  const [dateRange, setDateRange] = useState<number | string>(90);
  const [lastRefreshed, setLastRefreshed] = useState<Date>(new Date());

  const handleChange = (_event: ChangeEvent<HTMLButtonElement>, tab: number) => {
    setActiveTab(tab);
  };

  return (
    <QContainer maxWidth={false}>
      <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} mb={5}>
        <Box width={178}>
          <QDateRange formControlProps={{ fullWidth: true }} value={dateRange} onChange={value => setDateRange(value)} />
        </Box>
        <QTypography variant="body">Last refreshed: {moment(lastRefreshed).format('MMMM D, YYYY [at] h:mma')}</QTypography>
      </Box>
      <QTabContext value={activeTab}>
        <QTabList tabs="true" onChange={handleChange}>
          <QTab label="App Inventory" value={0} />
          <QTab label="Risk Insights" value={1} />
          <QTab label="Policy Violations" value={2} />
        </QTabList>
        <QTabPanel tabid="0" value={0} index={0}>
          <AppInventory />
        </QTabPanel>
        <QTabPanel tabid="1" value={1} index={1}>
          <RiskInsights />
        </QTabPanel>
        <QTabPanel tabid="2" value={2} index={2}>
          <PolicyViolations />
        </QTabPanel>
      </QTabContext>
    </QContainer>
  );
};
